import axios from '@/axios'

// reports
export async function ListActivities (page, parameters) {
  let url = import.meta.env.VITE_API_URL + '/v2/intranet/activities?page=' + page

  if (parameters) {
    url = url + parameters
  }

  const response = await axios.get(url)
  return response.data

  // const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/activities?page=' + page + parameters ?? '')
  // return response.data
}
export async function createActivities (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/activities', data)
  return response.data.data
}
export async function getActivities (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/activities/' + id)
  return response.data.data
}
export async function updateActivities (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/activities/' + id, data)
  return response.data.data
}
export async function deleteActivities (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/activities/' + id)
  return response.data.data
}
export async function addActivitieGrade (id, gradeId) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/activities/' + id + '/grades/' + gradeId)
  return response.data
}
export async function removeActivitieGrade (id, gradeId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/activities/' + id + '/grades/' + gradeId)
  return response.data
}

export default {
  ListActivities,
  getActivities,
  createActivities,
  updateActivities,
  deleteActivities,
  addActivitieGrade,
  removeActivitieGrade
}
